function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*! Selectionjs 1.4.1 MIT | https://github.com/Simonwep/selection */
!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.Selection = t() : e.Selection = t();
}(window, function () {
  return function (e) {
    var t = {};

    function o(n) {
      if (t[n]) return t[n].exports;
      var r = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(r.exports, r, r.exports, o), r.l = !0, r.exports;
    }

    return o.m = e, o.c = t, o.d = function (e, t, n) {
      o.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, o.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "u", {
        value: !0
      });
    }, o.t = function (e, t) {
      if (1 & t && (e = o(e)), 8 & t) return e;
      if (4 & t && "object" == _typeof(e) && e && e.u) return e;
      var n = Object.create(null);
      if (o.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var r in e) o.d(n, r, function (t) {
        return e[t];
      }.bind(null, r));
      return n;
    }, o.n = function (e) {
      var t = e && e.u ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return o.d(t, "a", t), t;
    }, o.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, o.p = "dist/", o(o.s = 1);
  }([function (e) {
    e.exports = JSON.parse('{"a":"1.4.1"}');
  }, function (e, t, o) {
    "use strict";

    function n(e, t) {
      var o = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), o.push.apply(o, n);
      }

      return o;
    }

    function r(e) {
      for (var t = 1; t < arguments.length; t++) {
        var o = null != arguments[t] ? arguments[t] : {};
        t % 2 ? n(o, !0).forEach(function (t) {
          c(e, t, o[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o)) : n(o).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(o, t));
        });
      }

      return e;
    }

    function c(e, t, o) {
      return t in e ? Object.defineProperty(e, t, {
        value: o,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = o, e;
    }

    function l(e, t, o, n) {
      var c = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
      t instanceof HTMLCollection || t instanceof NodeList ? t = Array.from(t) : Array.isArray(t) || (t = [t]), Array.isArray(o) || (o = [o]);
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _l = _step.value;
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = o[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var _t = _step2.value;

              _l[e](_t, n, r({
                capture: !1
              }, c));
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return Array.prototype.slice.call(arguments, 1);
    }

    o.r(t);

    var s = l.bind(null, "addEventListener"),
        i = l.bind(null, "removeEventListener"),
        u = function u(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "px";
      return "number" == typeof e ? e + t : e;
    };

    function a(e, t, o) {
      var n = e && e.style;
      if (n) if ("object" == _typeof(t)) for (var _i2 = 0, _Object$entries = Object.entries(t); _i2 < _Object$entries.length; _i2++) {
        var _ref3 = _Object$entries[_i2];

        var _ref2 = _slicedToArray(_ref3, 2);

        var _e2 = _ref2[0];
        var _o = _ref2[1];
        n[_e2] = u(_o);
      } else o && "string" == typeof t && (n[t] = u(o));
    }

    function f(e, t, o) {
      switch (o || "touch") {
        case "center":
          {
            var _o2 = t.left + t.width / 2,
                _n2 = t.top + t.height / 2;

            return _o2 >= e.left && _o2 <= e.right && _n2 >= e.top && _n2 <= e.bottom;
          }

        case "cover":
          return t.left >= e.left && t.top >= e.top && t.right <= e.right && t.bottom <= e.bottom;

        case "touch":
          return e.right >= t.left && e.left <= t.right && e.bottom >= t.top && e.top <= t.bottom;

        default:
          throw "Unkown intersection mode: ".concat(o);
      }
    }

    function d(e) {
      Array.isArray(e) || (e = [e]);
      var t = [];

      for (var _o4 = 0, _n3 = e.length; _o4 < _n3; _o4++) {
        var _n4 = e[_o4];
        "string" == typeof _n4 ? t.push.apply(t, _toConsumableArray(document.querySelectorAll(_n4))) : _n4 instanceof HTMLElement && t.push(_n4);
      }

      return t;
    }

    function p(e) {
      var t = e.path || e.composedPath && e.composedPath();
      if (t) return t;
      var o = e.target;

      for (t = [o]; o = o.parentElement;) t.push(o);

      return t.push(document, window), t;
    }

    function m(e, t) {
      var o = e.indexOf(t);
      ~o && e.splice(o, 1);
    }

    function v(e) {
      var t = e.touches && e.touches[0] || e;
      return {
        tap: t,
        x: t.clientX,
        y: t.clientY,
        target: t.target
      };
    }

    var b = o(0);

    var h = Math.abs,
        y = Math.max,
        _ = Math.min,
        g = Math.round,
        j = Math.ceil,
        w = document,
        x = function x(e) {
      return e.preventDefault();
    };

    function O() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var t = {
        options: Object.assign({
          class: "selection-area",
          mode: "touch",
          tapMode: "native",
          startThreshold: 10,
          singleClick: !0,
          disableTouch: !1,
          selectables: [],
          scrollSpeedDivider: 10,
          startareas: ["html"],
          boundaries: ["html"],
          selectionAreaContainer: "body"
        }, e),
        v: [],
        h: [],
        _: [],
        g: {
          added: [],
          removed: []
        },
        j: {
          beforestart: [],
          start: [],
          move: [],
          stop: []
        },
        O: w.createElement("div"),
        S: w.createElement("div"),
        T: !0,
        A: {
          x: null,
          y: null
        },
        L: function L() {
          t.S.appendChild(t.O), t.O.classList.add(t.options.class), a(t.O, {
            willChange: "top, left, bottom, right, width, height",
            top: 0,
            left: 0,
            position: "fixed"
          }), a(t.S, {
            overflow: "hidden",
            position: "fixed",
            transform: "translate3d(0, 0, 0)",
            pointerEvents: "none",
            zIndex: "1"
          }), t.enable();
        },
        M: function M(e) {
          var o = "on" === e ? s : i;
          o(w, "mousedown", t.k), t.options.disableTouch || o(w, "touchstart", t.k, {
            passive: !1
          });
        },
        k: function k(e) {
          var _v = v(e),
              o = _v.x,
              n = _v.y,
              r = _v.target,
              c = r.getBoundingClientRect(),
              l = d(t.options.startareas);

          t.C = d(t.options.boundaries), t.H = t.C.find(function (e) {
            return f(e.getBoundingClientRect(), c);
          });
          var i = p(e);
          t.H && l.find(function (e) {
            return i.includes(e);
          }) && t.C.find(function (e) {
            return i.includes(e);
          }) && !1 !== t.F("beforestart", e) && (t.q = o, t.D = n, t.N = 0, t.U = 0, t.W = !0, t._ = [], t.clearSelection(!1), s(w, "selectstart", x), s(w, ["touchmove", "mousemove"], t.I, {
            passive: !1
          }), s(w, ["mouseup", "touchcancel", "touchend"], t.J));
        },
        P: function P(e) {
          var o = t.options.tapMode,
              n = v(e);
          var r = null;
          if ("native" === o) r = n.target;else {
            if ("touch" !== o) throw "Unknown tapMode option: ".concat(o);
            {
              t.resolveSelectables();
              var _e3 = n.x,
                  _o5 = n.y;
              r = t.h.find(function (t) {
                var _t$getBoundingClientR = t.getBoundingClientRect(),
                    n = _t$getBoundingClientR.right,
                    r = _t$getBoundingClientR.left,
                    c = _t$getBoundingClientR.top,
                    l = _t$getBoundingClientR.bottom;

                return _e3 < n && _e3 > r && _o5 < l && _o5 > c;
              });
            }
          }
          if (!r) return !1;

          for (t.resolveSelectables(); !t.h.includes(r);) {
            if (!r.parentElement) return;
            r = r.parentElement;
          }

          t.F("start", e);
          var c = t.v;

          if (e.shiftKey && c.length) {
            var _o6 = c[c.length - 1],
                _ref6 = 4 & _o6.compareDocumentPosition(r) ? [r, _o6] : [_o6, r],
                _ref7 = _slicedToArray(_ref6, 2),
                _n5 = _ref7[0],
                _l2 = _ref7[1],
                _s2 = [].concat(_toConsumableArray(t.h.filter(function (e) {
              return 4 & e.compareDocumentPosition(_n5) && 2 & e.compareDocumentPosition(_l2);
            })), [r]);

            t.select(_s2), t.F("move", e), t.F("stop", e);
          } else t.v.includes(r) ? t.removeFromSelection(r) : t.select(r), t.F("move", e), t.F("stop", e);
        },
        I: function I(e) {
          var _v2 = v(e),
              o = _v2.x,
              n = _v2.y,
              r = t.options.startThreshold,
              c = t.q,
              l = t.D,
              u = _typeof(r);

          if ("number" === u && h(o + n - (c + l)) >= r || "object" === u && h(o - c) >= r.x || h(n - l) >= r.y) {
            i(w, ["mousemove", "touchmove"], t.I, {
              passive: !1
            }), s(w, ["mousemove", "touchmove"], t.B, {
              passive: !1
            }), a(t.O, "display", "block"), d(t.options.selectionAreaContainer)[0].appendChild(t.S), t.resolveSelectables(), t.W = !1;

            var _o7 = t.G = t.H.getBoundingClientRect();

            g(t.H.scrollHeight) !== g(_o7.height) || g(t.H.scrollWidth) !== g(_o7.width) ? (t.T = !0, s(window, "wheel", t.K, {
              passive: !1
            }), t.h = t.h.filter(function (e) {
              return t.H.contains(e);
            }), a(t.S, {
              top: _o7.top,
              left: _o7.left,
              width: _o7.width,
              height: _o7.height
            }), a(t.O, {
              marginTop: -_o7.top,
              marginLeft: -_o7.left
            })) : (t.T = !1, a(t.S, {
              top: 0,
              left: 0,
              width: "100%",
              height: "100%"
            }), a(t.O, {
              marginTop: 0,
              marginLeft: 0
            })), t.B(e), t.F("start", e);
          }

          e.preventDefault();
        },
        B: function B(e) {
          var _v3 = v(e),
              o = _v3.x,
              n = _v3.y,
              r = t.H;

          var c = t.A;
          t.N = o, t.U = n, !t.T || null === c.y && null === c.x ? (t.R(), t.V(), t.F("move", e)) : requestAnimationFrame(function o() {
            if (null === (c = t.A).y && null === c.x) return;
            var n = r.scrollTop,
                l = r.scrollLeft;
            null !== c.y && (r.scrollTop += j(c.y / t.options.scrollSpeedDivider), t.D -= r.scrollTop - n), null !== c.x && (r.scrollLeft += j(c.x / t.options.scrollSpeedDivider), t.q -= r.scrollLeft - l), t.R(), t.V(), t.F("move", e), requestAnimationFrame(o);
          }), e.preventDefault();
        },
        K: function K(e) {
          var o = t.options.scrollSpeedDivider;
          t.A.y += o * (-1 * e.wheelDeltaY), t.A.x += o * (-1 * e.wheelDeltaX), t.B(e), e.preventDefault();
        },
        R: function R() {
          var _t$H = t.H,
              e = _t$H.scrollTop,
              o = _t$H.scrollHeight,
              n = _t$H.clientHeight,
              r = _t$H.scrollLeft,
              c = _t$H.scrollWidth,
              l = _t$H.clientWidth,
              s = t.G,
              i = t.A;
          var u = t.N,
              a = t.U;
          u < s.left ? (i.x = r ? -h(s.left - u) : null, u = s.left) : u > s.left + s.width ? (i.x = c - r - l ? h(s.left + s.width - u) : null, u = s.left + s.width) : i.x = null, a < s.top ? (i.y = e ? -h(s.top - a) : null, a = s.top) : a > s.top + s.height ? (i.y = o - e - n ? h(s.top + s.height - a) : null, a = s.top + s.height) : i.y = null;

          var f = _(t.q, u),
              d = _(t.D, a),
              p = y(t.q, u),
              m = y(t.D, a);

          Object.assign(t.O.style, {
            top: "".concat(d, "px"),
            left: "".concat(f, "px"),
            width: "".concat(p - f, "px"),
            height: "".concat(m - d, "px")
          });
        },
        J: function J(e, o) {
          i(w, ["mousemove", "touchmove"], t.I), i(w, ["touchmove", "mousemove"], t.B), i(w, ["mouseup", "touchcancel", "touchend"], t.J), e && t.W && t.options.singleClick ? t.P(e) : t.W || o || (t.V(), t.F("stop", e)), t.A = {
            x: null,
            y: null
          }, i(window, "wheel", t.K), t.S.remove(), i(w, "selectstart", x), a(t.O, "display", "none");
        },
        V: function V() {
          var e = t._,
              o = t.h,
              n = t.O,
              r = t.options,
              c = r.mode,
              l = n.getBoundingClientRect(),
              s = [],
              i = [],
              u = [];

          for (var _t3, _n7 = 0, _r2 = o.length; _t3 = o[_n7], _n7 < _r2; _n7++) f(l, _t3.getBoundingClientRect(), c) && (e.includes(_t3) || i.push(_t3), s.push(_t3));

          for (var _t5, _o9 = 0, _n9 = e.length; _t5 = e[_o9], _o9 < _n9; _o9++) s.includes(_t5) || u.push(_t5);

          t._ = s, t.g = {
            added: i,
            removed: u
          };
        },
        F: function F(e, o) {
          var n = !0;
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = t.j[e][Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var _r3 = _step3.value;
              n = _r3.call(t, {
                inst: t,
                area: t.O,
                selected: t._.concat(t.v),
                changed: t.g,
                oe: o
              }) && n;
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }

          return n;
        },
        on: function on(e, o) {
          return t.j[e].push(o), t;
        },
        off: function off(e, o) {
          var n = t.j[e];

          if (n) {
            var _e4 = n.indexOf(o);

            ~_e4 && n.splice(_e4, 1);
          }

          return t;
        },
        resolveSelectables: function resolveSelectables() {
          t.h = d(t.options.selectables);
        },
        keepSelection: function keepSelection() {
          var e = t._,
              o = t.v;

          for (var _t7, _n11 = 0, _r5 = e.length; _t7 = e[_n11], _n11 < _r5; _n11++) o.includes(_t7) || o.push(_t7);
        },
        clearSelection: function clearSelection() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
          e && (t.v = []), t._ = [], t.g.added = [], t.g.removed = [];
        },
        removeFromSelection: function removeFromSelection(e) {
          t.g.removed.push(e), m(t.v, e), m(t._, e);
        },
        getSelection: function getSelection() {
          return t.v;
        },
        cancel: function cancel() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
          t.J(null, !e);
        },
        option: function option(e, o) {
          var n = t.options;
          return void 0 === o ? n[e] : n[e] = o;
        },
        disable: function disable() {
          t.M("off");
        },
        destroy: function destroy() {
          t.disable(), t.S.remove();
        },
        enable: function enable() {
          t.M("on");
        },
        select: function select(e) {
          var _t$_, _t$g$added;

          var o = t._,
              n = t.v,
              r = d(e).filter(function (e) {
            return !o.includes(e) && !n.includes(e);
          });
          return (_t$_ = t._).push.apply(_t$_, _toConsumableArray(r)), (_t$g$added = t.g.added).push.apply(_t$g$added, _toConsumableArray(r)), r;
        }
      };
      return t.L(), t;
    }

    O.utils = {
      on: s,
      off: i,
      css: a,
      intersects: f,
      selectAll: d,
      eventPath: p,
      removeElement: m
    }, O.create = function (e) {
      return O(e);
    }, O.version = b.a;
    t.default = O;
  }]).default;
});